import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/img/uic (2).png';
import _imports_1 from '../../assets/img/wd (1).png';
import _imports_2 from '../../assets/img/usdt.jpg';
const _withScopeId = n => (_pushScopeId("data-v-26acdbd0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "caodi"
};
const _hoisted_2 = {
  class: "user"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "1rem"
  }
}, null, -1));
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "info",
  style: {
    "width": "100%",
    "text-align": "center",
    "display": "block"
  }
};
const _hoisted_6 = {
  class: "user_id"
};
const _hoisted_7 = {
  class: "user_uname"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_9 = {
  class: "info",
  style: {
    "padding-top": "0.1rem",
    "justify-content": "space-around"
  }
};
const _hoisted_10 = {
  class: "user_uname",
  style: {
    "background": "rgba(0, 0, 0, 0.1)",
    "padding": "0 0.1rem",
    "border-radius": "0.3rem",
    "margin-right": "0.1rem",
    "width": "auto"
  }
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont",
  style: {
    "font-size": "0.3rem",
    "color": "#ffd600",
    "padding-right": "0.1rem"
  }
}, "", -1));
const _hoisted_12 = {
  style: {
    "font-size": "0.2rem",
    "padding": "0 0.3rem"
  }
};
const _hoisted_13 = {
  class: "user_uname",
  style: {
    "background": "rgba(0, 0, 0, 0.1)",
    "padding": "0 0.1rem",
    "border-radius": "0.3rem",
    "margin-right": "0.1rem",
    "width": "auto"
  }
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));
const _hoisted_15 = {
  style: {
    "font-size": "0.2rem",
    "padding": "0 0.3rem"
  }
};
const _hoisted_16 = {
  class: "user_uname",
  style: {
    "background": "rgba(0, 0, 0, 0.1)",
    "border-radius": "0.3rem",
    "padding": "0 0.1rem",
    "width": "auto"
  }
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1));
const _hoisted_18 = {
  style: {
    "font-size": "0.2rem",
    "padding": "0 0.3rem"
  }
};
const _hoisted_19 = {
  class: "total"
};
const _hoisted_20 = {
  class: "team_tit"
};
const _hoisted_21 = {
  class: "login_form"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logite"
}, "DIGITAL WALLET", -1));
const _hoisted_23 = {
  class: "yaoqin"
};
const _hoisted_24 = {
  class: "yaoqing"
};
const _hoisted_25 = {
  class: "qb_yue"
};
const _hoisted_26 = {
  class: "qb_no"
};
const _hoisted_27 = {
  class: "qb_btn"
};
const _hoisted_28 = {
  class: "qb_btn"
};
const _hoisted_29 = {
  class: "qb_btn"
};
const _hoisted_30 = {
  class: "yaoqing"
};
const _hoisted_31 = {
  class: "qb_yue"
};
const _hoisted_32 = {
  class: "qb_yued"
};
const _hoisted_33 = {
  class: "qb_btn"
};
const _hoisted_34 = {
  class: "qb_btn"
};
const _hoisted_35 = {
  class: "yaoqing"
};
const _hoisted_36 = {
  class: "qb_yue"
};
const _hoisted_37 = {
  class: "qb_yued"
};
const _hoisted_38 = {
  class: "qb_no"
};
const _hoisted_39 = {
  class: "qb_btn"
};
const _hoisted_40 = {
  class: "qb_btn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_tab = _resolveComponent("van-tab");
  const _component_van_tabs = _resolveComponent("van-tabs");
  const _component_Footer = _resolveComponent("Footer");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_nav_bar, {
    title: $data.lang.u1,
    onClickLeft: $options.back,
    onClickRight: $options.onClickLeft
  }, {
    left: _withCtx(() => [_createVNode(_component_van_icon, {
      name: "arrow-left"
    })]),
    right: _withCtx(() => [_createVNode(_component_van_icon, {
      name: "chat-o",
      size: "18"
    })]),
    _: 1
  }, 8, ["title", "onClickLeft", "onClickRight"]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", {
    class: _normalizeClass($data.head_bg ? 'user_img head_img' + $data.head_bg : 'user_img head_img15')
  }, [_createElementVNode("img", {
    src: $data.app_root + $data.user.head
  }, null, 8, _hoisted_4)], 2), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, "ID " + _toDisplayString($data.user.id), 1), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("span", null, _toDisplayString($data.user.user_name), 1)])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("span", _hoisted_12, _toDisplayString($data.user.ege), 1), _createTextVNode(" + ")]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("span", _hoisted_15, _toDisplayString($data.user.niunai), 1), _createTextVNode(" + ")]), _createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("span", _hoisted_18, _toDisplayString($data.user.jinbi), 1), _createTextVNode(" + ")])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("p", _hoisted_20, "≈" + _toDisplayString(Number($data.user.yued) + Number($data.user.yued1) + Number($data.user.jinbi)) + "USDT", 1)])]), _createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("div", _hoisted_23, [_createVNode(_component_van_tabs, {
    active: $data.active,
    "onUpdate:active": _cache[7] || (_cache[7] = $event => $data.active = $event)
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tab, {
      title: 'USDT'
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, _toDisplayString($data.user.jinbi), 1), _createElementVNode("div", _hoisted_26, _toDisplayString($data.lang.t12) + _toDisplayString($data.user.jinbi1) + "," + _toDisplayString($data.lang.t13), 1), _createElementVNode("div", _hoisted_27, [_createVNode(_component_van_button, {
        round: "",
        block: "",
        type: "primary",
        size: "small",
        "native-type": "submit",
        color: "linear-gradient(180deg, #162B3F 0%, #17335A 50%, #162B3F 100%)",
        onClick: _cache[0] || (_cache[0] = $event => $options.goto('rec'))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.lang.t3), 1)]),
        _: 1
      })]), _createElementVNode("div", _hoisted_28, [_createVNode(_component_van_button, {
        round: "",
        block: "",
        type: "primary",
        size: "small",
        "native-type": "submit",
        color: "linear-gradient(180deg, #162B3F 0%, #17335A 50%, #162B3F 100%)",
        onClick: _cache[1] || (_cache[1] = $event => $options.goto('apply'))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.lang.t4), 1)]),
        _: 1
      })]), _createElementVNode("div", _hoisted_29, [_createVNode(_component_van_button, {
        round: "",
        block: "",
        type: "primary",
        size: "small",
        "native-type": "submit",
        color: "linear-gradient(180deg, #162B3F 0%, #17335A 50%, #162B3F 100%)",
        onClick: _cache[2] || (_cache[2] = $event => $options.goto('reward'))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.lang.t7), 1)]),
        _: 1
      })])])]),
      _: 1
    }), _createVNode(_component_van_tab, {
      title: $data.lang.tt2
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, _toDisplayString($data.user.ege), 1), _createElementVNode("div", _hoisted_32, "≈" + _toDisplayString($data.user.yued1) + "USDT", 1), _createElementVNode("div", _hoisted_33, [_createVNode(_component_van_button, {
        round: "",
        block: "",
        type: "primary",
        size: "small",
        "native-type": "submit",
        color: "linear-gradient(180deg, #162B3F 0%, #17335A 50%, #162B3F 100%)",
        onClick: _cache[3] || (_cache[3] = $event => $options.goto('trade'))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.lang.t14), 1)]),
        _: 1
      })]), _createElementVNode("div", _hoisted_34, [_createVNode(_component_van_button, {
        round: "",
        block: "",
        type: "primary",
        size: "small",
        "native-type": "submit",
        color: "linear-gradient(180deg, #162B3F 0%, #17335A 50%, #162B3F 100%)",
        onClick: _cache[4] || (_cache[4] = $event => $options.goto('ege'))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.lang.t7), 1)]),
        _: 1
      })])])]),
      _: 1
    }, 8, ["title"]), _createVNode(_component_van_tab, {
      title: $data.lang.tt1
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, _toDisplayString($data.user.niunai), 1), _createElementVNode("div", _hoisted_37, "≈" + _toDisplayString($data.user.yued) + "USDT", 1), _createElementVNode("div", _hoisted_38, _toDisplayString($data.lang.t12) + _toDisplayString($data.user.niunai1) + "," + _toDisplayString($data.lang.t13), 1), _createElementVNode("div", _hoisted_39, [_createVNode(_component_van_button, {
        round: "",
        block: "",
        type: "primary",
        size: "small",
        "native-type": "submit",
        color: "linear-gradient(180deg, #162B3F 0%, #17335A 50%, #162B3F 100%)",
        onClick: _cache[5] || (_cache[5] = $event => $options.goto('gets'))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.lang.t15), 1)]),
        _: 1
      })]), _createElementVNode("div", _hoisted_40, [_createVNode(_component_van_button, {
        round: "",
        block: "",
        type: "primary",
        size: "small",
        "native-type": "submit",
        color: "linear-gradient(180deg, #162B3F 0%, #17335A 50%, #162B3F 100%)",
        onClick: _cache[6] || (_cache[6] = $event => $options.goto('point'))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.lang.t7), 1)]),
        _: 1
      })])])]),
      _: 1
    }, 8, ["title"])]),
    _: 1
  }, 8, ["active"])])]), _createVNode(_component_Footer, {
    lang_list: $data.lang_list,
    lang: $data.lang
  }, null, 8, ["lang_list", "lang"])])]);
}